import { useState } from "react"
import { useI18n } from "providers/I18n"

import Select, { SelectedOptionChanges } from "ui/inputs/Select"
import { FilterOption } from "./filters-api"

const kinds_of_amount = ["net", "gross", "total"] as const

export type KindOfAmount = (typeof kinds_of_amount)[number]

export function useNetGrossTotalFilterState() {
  const [value, setValue] = useState<KindOfAmount>(() => "net")
  const onValueChange = (x: KindOfAmount) => setValue(x)
  return { value, onValueChange }
}

export type NetGrossTotalFilterProps = {
  value: KindOfAmount
  onValueChange: (x: KindOfAmount) => void
}

export function NetGrossTotalFilter(props: NetGrossTotalFilterProps) {
  const { value, onValueChange } = props
  const { t } = useI18n()
  const options = kinds_of_amount.map((x) => ({
    value: x,
    label: t(`dashboards.filters.kinds_of_amount.${x}`),
  }))

  const onChange = (o: SelectedOptionChanges<FilterOption>) => {
    const v = o.value
    if (v) {
      onValueChange(v as KindOfAmount)
    }
  }

  return (
    <Select
      options={options}
      value={value || "NOPE"}
      onSelectedOptionChange={onChange}
    />
  )
}
